import { TYPES_OF_TILE } from '../../../../constants'

import { mobileUnitTilePrimaryKeyColumns } from '../../dis/tile/mobile-unit/MobileUnitsForm'
import { masterDateTimeTilePrimaryKeyColumns } from '../../dis/tile/master-datetime/MasterDateTimeForm'
import { textSearchTilePrimaryKeyColumns } from '../../dis/tile/text-search/TextSearchForm'

export function getDefaultColumnsByViewType(tileType, environment) {
	switch (tileType) {
		case TYPES_OF_TILE.MOBILE_UNITS:
			// reference to Mobile unit form
			const formattedVariableColumns = environment?.mobileUnitVariableColumns?.map(
				(variable, index) => ({
					title: variable.title,
					name: `Variable${index + 1}`,
					type: variable.type,
				})
			)
			return [...mobileUnitTilePrimaryKeyColumns, ...formattedVariableColumns]
		case TYPES_OF_TILE.MASTER_DATETIME:
			return masterDateTimeTilePrimaryKeyColumns
		case TYPES_OF_TILE.TEXT_SEARCH:
			return textSearchTilePrimaryKeyColumns
		default:
			return []
	}
}

export function isTextType(columnType) {
	return ['text', 'string'].includes(columnType?.toLowerCase())
}

export function isNumberType(columnType) {
	return ['integer', 'float', 'numeric', 'number'].includes(columnType?.toLowerCase())
}

export function isDateTimeType(columnType) {
	return ['date', 'datetime', 'time'].includes(columnType?.toLowerCase())
}

export function haveSameType(typeA, typeB) {
	return (
		(isTextType(typeA) && isTextType(typeB)) ||
		(isNumberType(typeA) && isNumberType(typeB)) ||
		(isDateTimeType(typeA) && isDateTimeType(typeB))
	)
}
